import React from "react";

const SolgariLogo = () => (
  <svg
    version="1.1"
    viewBox="0 0 2048 2048"
    width="40"
    height="40"
    xmlns="http://www.w3.org/2000/svg"
    className="copilot-svg"
  >
    <rect width="2048" height="2048" fill="#2141B3" />
    <path
      transform="translate(990,300) scale(1.4)"
      d="m0 0h64l53 5 39 6 29 6 27 7 36 12 24 10 17 8 17 10 2 2-1 5-9 20-7 14-13 28-17 35-12 24-4 2-23-12-25-10-33-11-36-9-31-5-18-2-16-1h-57l-26 3-20 4-18 6-19 9-12 8-11 9-9 10-8 14-7 18-3 16-1 9v30l3 16 7 19 8 13 8 10 9 10 16 12 15 9 16 8 20 9 23 9 48 18 43 14 35 12 40 16 26 12 26 14 21 13 17 12 14 11 12 11 8 7 7 8 12 14 11 15 10 16 13 27 10 30 6 27 4 30 1 11v35l-3 30-5 28-5 19-7 21-11 24-10 17-13 17-9 11-11 12-12 12-17 13-15 10-15 9-27 13-24 9-30 9-30 7-30 5-35 3-27 1h-19l-37-2-36-4-36-7-39-9-32-9-27-9-25-10-34-16-26-14-22-14-16-11-6-7 1-5 10-14 15-25 13-20 7-11 13-18 12-20 5-6 5 1 15 11 16 10 28 15 28 13 37 14 34 10 29 7 30 5 20 2 19 1h20l26-2 23-4 18-5 25-10 19-9 16-11 13-12 11-15 9-17 6-17 3-13 1-10v-26l-2-19-5-16-8-16-10-16-9-10-14-11-10-7-15-9-29-15-36-16-24-9-30-11-28-10-33-12-37-15-25-11-24-12-24-14-12-8-14-11-10-9-8-7-11-11-9-11-8-10-12-19-12-24-11-30-7-26-5-25-2-15-1-18v-17l2-22 5-27 7-25 9-24 11-23 12-19 14-17 9-10 8-8 11-9 12-10 19-13 20-11 23-10 19-7 25-7 23-5 39-6z"
      fill="#FCFCFC"
    />
  </svg>
);
export default SolgariLogo;
